import React, { AnchorHTMLAttributes, ReactNode } from 'react';
import { useNavigation, NavigateOptions } from 'context/NavigationContext';

interface NavigationLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: ReactNode;
  external?: boolean;
  replace?: boolean;
}

export const NavigationLink = ({
  href,
  children,
  external,
  replace,
  onClick,
  ...rest
}: NavigationLinkProps) => {
  const { navigate } = useNavigation();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Allow default browser behavior for ctrl/cmd+click or middle mouse click
    if (e.ctrlKey || e.metaKey || e.button === 1) {
      if (onClick) onClick(e);
      return;
    }

    e.preventDefault();

    if (onClick) {
      onClick(e);
    }

    const options: NavigateOptions = {
      external,
      replace,
    };

    navigate(href, options);
  };

  return (
    <a href={href} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
};

export default NavigationLink;
